import { render, staticRenderFns } from "./PlanRegistration.vue?vue&type=template&id=4900d2d9&scoped=true&"
import script from "./PlanRegistration.vue?vue&type=script&lang=js&"
export * from "./PlanRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PlanRegistration.vue?vue&type=style&index=0&id=4900d2d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900d2d9",
  null
  
)

export default component.exports